module.exports = __webpack_public_path__ + "static/img/status-false.bc533f0b.svg";